<template>
  <div class="allocation-storehouse-enter-container">
    <ds-page-header :title="$t('allocationStorehouseEnter.page.title')" :subtitle="$t('allocationStorehouseEnter.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('common.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="handleSubmit">
          {{ $t('allocationStorehouseEnter.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('allocationStorehouseEnter.title') }}</span>
        </template>
        <template #right>
          <span class="ds-num ds-toolbar__meta">{{ $t('allocationStorehouseEnter.applyId') }}{{ allocationStorehouseEnterInfo.applyId || '-' }}</span>
        </template>
      </ds-toolbar>
      <ds-data-table :data="allocationStorehouseEnterInfo.resourceStores" :loading="loading" border
        :empty-description="$t('allocationStorehouseEnter.page.empty')" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column :label="$t('allocationStorehouseEnter.resourceType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName }} &gt; {{ scope.row.rstName }}
          </template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('allocationStorehouseEnter.resourceName')" align="center" min-width="140" />
        <el-table-column :label="$t('allocationStorehouseEnter.specification')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.specName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="resCode" :label="$t('allocationStorehouseEnter.resourceCode')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resCode || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('allocationStorehouseEnter.fixedResource')" align="center" width="90" />
        <el-table-column
          :label="allocationStorehouseEnterInfo.applyType == '10000' || allocationStorehouseEnterInfo.applyType == '30000' ? $t('allocationStorehouseEnter.transferredWarehouse') : $t('allocationStorehouseEnter.returnPerson')"
          align="center" min-width="120">
          <template slot-scope="scope">
            {{ allocationStorehouseEnterInfo.applyType == '10000' || allocationStorehouseEnterInfo.applyType ==
              '30000' ? scope.row.shaName : allocationStorehouseEnterInfo.startUserName }}
          </template>
        </el-table-column>
        <el-table-column prop="shaName" :label="$t('allocationStorehouseEnter.originalWarehouse')" align="center" min-width="110" />
        <el-table-column prop="shzName" :label="$t('allocationStorehouseEnter.targetWarehouse')" align="center" min-width="110" />
        <el-table-column
          :label="$t('allocationStorehouseEnter.originalStock') + '(' + (allocationStorehouseEnterInfo.applyType == '30000' ? $t('allocationStorehouseEnter.targetWarehouse') : $t('allocationStorehouseEnter.transferredWarehouse')) + ')'"
          align="center" width="140">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.originalStock }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('allocationStorehouseEnter.transferQuantity')" align="center" width="130">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.stock }}{{ scope.row.applyType == 20000 ? scope.row.miniUnitCodeName :
              scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('allocationStorehouseEnter.actualQuantity')" align="center" min-width="170">
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.quantity" type="number"
              :placeholder="$t('allocationStorehouseEnter.quantityPlaceholder')" style="width: 100%" clearable />
          </template>
        </el-table-column>
      </ds-data-table>
    </div>
  </div>
</template>

<script>
import { listAllocationStorehouses, allocationStoreEnter } from '@/api/resource/allocationStorehouseEnterApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'AllocationStorehouseEnterList',
  components: {
    DsPageHeader,
    DsToolbar,
    DsDataTable
  },
  data() {
    return {
      loading: false,
      allocationStorehouseEnterInfo: {
        resourceStores: [],
        applyId: '',
        taskId: '',
        selectResIds: []
      }
    }
  },
  created() {
    this.allocationStorehouseEnterInfo.applyId = this.$route.query.applyId
    this.allocationStorehouseEnterInfo.taskId = this.$route.query.taskId
    this.listAllocationStorehouseApply()
  },
  methods: {
    async listAllocationStorehouseApply() {
      try {
        this.loading = true
        const params = {
          page: 1,
          row: 100,
          applyId: this.allocationStorehouseEnterInfo.applyId
        }
        const { data } = await listAllocationStorehouses(params)
        this.allocationStorehouseEnterInfo.resourceStores = data
      } catch (error) {
        this.$message.error(this.$t('allocationStorehouseEnter.fetchError'))
      } finally {
        this.loading = false
      }
    },
    handleSelectionChange(val) {
      this.allocationStorehouseEnterInfo.selectResIds = val.map(item => item.resId)
    },
    async handleSubmit() {
      const selectedItems = this.allocationStorehouseEnterInfo.resourceStores.filter(item =>
        this.allocationStorehouseEnterInfo.selectResIds.includes(item.resId)
      )
      if (selectedItems.length === 0) {
        this.$message.warning(this.$t('allocationStorehouseEnter.selectItemsWarning'))
        return
      }
      let hasError = false
      selectedItems.forEach(item => {
        if (!item.quantity || parseFloat(item.quantity) <= 0) {
          hasError = true
          return
        }
        item.quantity = parseFloat(item.quantity)
      })
      if (hasError) {
        this.$message.warning(this.$t('allocationStorehouseEnter.quantityWarning'))
        return
      }
      this.allocationStorehouseEnterInfo.resourceStores = selectedItems
      try {
        await allocationStoreEnter(this.allocationStorehouseEnterInfo)
        this.$message.success(this.$t('common.operationSuccess'))
        this.goBack()
      } catch (error) {
        this.$message.error(error.message || this.$t('allocationStorehouseEnter.submitError'))
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.allocation-storehouse-enter-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
.ds-toolbar__meta {
  font-size: var(--ds-font-size-sm);
  color: var(--ds-gray-500);
}
</style>
